import React from "react";
import Row from "react-bootstrap/Row";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, MARKS } from "@contentful/rich-text-types";
import { colors, resolveColor } from "utils/styles";

import getKey from "utils/getKey";
// import { sizeEqualOrLessThan } from "utils/helpers";

export default function MetaTitle(props) {
	// const smOrSmaller = sizeEqualOrLessThan("sm");

	const fields = props.metaTitle?.fields;
	const text = props.text;

	const backgroundColor = fields?.backgroundColor ? resolveColor(fields?.backgroundColor) : null;
	const marginBottom = fields?.marginBottom !== undefined ? `${fields?.marginBottom}` : 1;
	return (
		<div className="metaTitle">
			<>
				{fields?.text &&
					documentToReactComponents(fields.text, {
						renderText: (text) =>
							text.split("\n").flatMap((text, i) => [i > 0 && <br key={getKey()} />, text]),

						renderNode: {
							[BLOCKS.HEADING_5]: (node, children) => {
								return (
									<h5 key={getKey()} className={backgroundColor ? "has-background" : " "}>
										{children}
									</h5>
								);
							},
							[BLOCKS.PARAGRAPH]: (node, children) => {
								return (
									<h5 key={getKey()} className={backgroundColor ? "has-background" : " "}>
										{children}
									</h5>
								);
							},
							[BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
								return (
									<img
										key={getKey()}
										src={node.data.target.fields.media.fields.file.url}
										alt={node.data.target.fields.altText}
									/>
								);
							},
						},
					})}

				{text && <h5>{text}</h5>}
			</>
			<style jsx="true">{`
				.metaTitle {
					text-align: ${fields?.textAlign || props.textAlign || "start"};
					justify-content: ${fields?.textAlign || "start"};
				}
				h5,
				p {
					margin-bottom: ${marginBottom}em;
				}

				.has-background:not(:empty) {
					padding: 0.5em;
					background: ${backgroundColor};
					display: inline-block;
					margin-bottom: ${marginBottom}em;
				}
				h5 {
					font-size: 17px;
					line-height: 28px;
					font-weight: bold;
					font-family: "Open Sans";
					color: ${fields?.color
						? resolveColor(fields?.color)
						: props.color
						? props.color
						: colors.lightBrown};
					text-transform: uppercase;
					margin-bottom: ${marginBottom}em;
					letter-spacing: 0px;
				}
			`}</style>
		</div>
	);
}
